import React from 'react';
import KogInputTextOutlinedControlled from '@/main/components/shared/inputText/inputTextOutlinedControlled';
import { useFormContext, useWatch } from 'react-hook-form';
import { getTranslateByKey } from '@/main/services/utils';
import { QuoteSupplierItemPartResponse } from '@/main/models/response';
import * as S from '../../styles';

interface IStockInputProps {
  fieldPrefix: string;
  showFieldWithouEdit?: boolean;
  row: QuoteSupplierItemPartResponse;
}

export default function ColumnStock({ fieldPrefix, showFieldWithouEdit, row }: IStockInputProps) {
  const { control } = useFormContext();

  const watcherNotQuote = useWatch({
    control,
    name: `${fieldPrefix}.notQuote`,
    defaultValue: false
  });

  if (showFieldWithouEdit && row.stock !== 0) {
    return <S.TextAlignTable>{row.stock}</S.TextAlignTable>;
  }

  return (
    <KogInputTextOutlinedControlled
      id="id-createAnswer-txt-stock"
      name={`${fieldPrefix}.stock`}
      placeholder={getTranslateByKey('information.amount')}
      label=""
      hasOnlyNumberInteger
      hideValue={watcherNotQuote}
      disabledMessage
      disabled={watcherNotQuote}
      control={control}
      sx={{ maxWidth: '65px', '& .MuiInputBase-input': { textAlign: 'center' } }}
      inputProps={{ maxLength: 5 }}
      controllerProps={{
        rules: {}
      }}
    />
  );
}
